import React from "react";
import { DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const TimezoneDropdown = (props: DropdownWithoutOptionsProps<server.dto.TimeZone, string>) => {
  return <BaseReactSelectDropdown
    options={serverReference.timezones}
    value={props.value}
    onChange={tz => { props.onChange(tz); }}
    getLabel={tz => `(${tz.utcOffset}) ${tz.value}`}
    getSubLabel={tz => tz.displayName}
    getValue={tz => tz.value}
    excludeKeys={[]}
    config={{
      isSearchable: true,
      shouldRenderSelectedValue: true,
      ...props.config,
    }}
  />
}

export default TimezoneDropdown;